export default "__VITE_ASSET__Cyu7zG8b__"